<template>
	<Modal @close="$emit('close')">
		<template v-slot:title>Reject Order</template>
		<template v-slot:body>
			<p class="int_type mgb_10" style="width: 30vw;">
				<input ref="rejectInput" type="text" v-model.trim="status_reason" placeholder="Please, Write the message for reject" />
			</p>
			<div class="bottom_bt_box">
				<ul>
					<li>
						<a href="javascript:;" class="gray_bt" @click="$emit('reject', status_reason)">Reject</a>
					</li>
				</ul>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
export default {
	data: () => ({
		status_reason: null,
	}),
	components: {
		Modal,
	},
};
</script>

<style></style>
